import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

const FeaturePhoneMarketDashboard = () => {
  const [selectedYear, setSelectedYear] = useState('2022');

  // Sales trend data
  const trendData = [
    { year: '2022', sales: 3480633, salesMillions: 3.481 },
    { year: '2023', sales: 2293932, salesMillions: 2.294 },
    { year: '2024', sales: 1457445, salesMillions: 1.457 },
    { year: '2025 Jan-May', sales: 391986, salesMillions: 0.392 }
  ];

  // Complete market data
  const data = {
    2022: {
      totalMarket: 3480633,
      topModels: [
        { model: 'AT&T Cingular Flip IV', brand: 'AT&T', sales: 434945, marketShare: 12.5 },
        { model: 'Nokia HMD 2760 Flip', brand: 'Nokia HMD', sales: 423813, marketShare: 12.2 },
        { model: 'Alcatel GO FLIP 3', brand: 'Alcatel', sales: 308484, marketShare: 8.9 },
        { model: 'Nokia HMD 2720 V Flip', brand: 'Nokia HMD', sales: 261014, marketShare: 7.5 },
        { model: 'TCL Flip Pro', brand: 'TCL', sales: 245202, marketShare: 7.0 },
        { model: 'Alcatel GO FLIP 4', brand: 'Alcatel', sales: 195603, marketShare: 5.6 },
        { model: 'Alcatel MyFlip 2', brand: 'Alcatel', sales: 181129, marketShare: 5.2 },
        { model: 'AT&T Cingular Flex', brand: 'AT&T', sales: 142566, marketShare: 4.1 }
      ],
      topChannels: [
        { channel: 'USA Other', sales: 1006937, marketShare: 28.9 },
        { channel: 'Walmart', sales: 849950, marketShare: 24.4 },
        { channel: 'Verizon', sales: 296852, marketShare: 8.5 },
        { channel: 'AT&T', sales: 243396, marketShare: 7.0 },
        { channel: 'Metro by T-Mobile', sales: 230781, marketShare: 6.6 },
        { channel: 'T-Mobile', sales: 208913, marketShare: 6.0 },
        { channel: 'Best Buy', sales: 141897, marketShare: 4.1 },
        { channel: 'Verizon Prepaid', sales: 132053, marketShare: 3.8 }
      ],
      topBrands: [
        { brand: 'Nokia HMD', sales: 878552, marketShare: 25.2 },
        { brand: 'Alcatel', sales: 827027, marketShare: 23.8 },
        { brand: 'TCL', sales: 639192, marketShare: 18.4 },
        { brand: 'AT&T', sales: 577511, marketShare: 16.6 },
        { brand: 'Schok', sales: 130164, marketShare: 3.7 }
      ]
    },
    2023: {
      totalMarket: 2293932,
      topModels: [
        { model: 'Nokia HMD 2760 Flip', brand: 'Nokia HMD', sales: 330238, marketShare: 14.4 },
        { model: 'Nokia HMD 2780 Flip', brand: 'Nokia HMD', sales: 215978, marketShare: 9.4 },
        { model: 'TCL Flip Pro', brand: 'TCL', sales: 177925, marketShare: 7.8 },
        { model: 'TCL Flip 2', brand: 'TCL', sales: 147682, marketShare: 6.4 },
        { model: 'TCL Flip Go', brand: 'TCL', sales: 135441, marketShare: 5.9 },
        { model: 'Alcatel SMARTFLIP', brand: 'Alcatel', sales: 125476, marketShare: 5.5 },
        { model: 'Nokia HMD 2720 V Flip', brand: 'Nokia HMD', sales: 119509, marketShare: 5.2 },
        { model: 'Schok Flip', brand: 'Schok', sales: 118218, marketShare: 5.2 }
      ],
      topChannels: [
        { channel: 'Walmart', sales: 708902, marketShare: 30.9 },
        { channel: 'USA Other', sales: 409197, marketShare: 17.8 },
        { channel: 'Verizon', sales: 220494, marketShare: 9.6 },
        { channel: 'Best Buy', sales: 168442, marketShare: 7.3 },
        { channel: 'T-Mobile', sales: 153341, marketShare: 6.7 },
        { channel: 'Metro by T-Mobile', sales: 132556, marketShare: 5.8 },
        { channel: 'Target', sales: 119552, marketShare: 5.2 },
        { channel: 'Verizon Prepaid', sales: 82074, marketShare: 3.6 }
      ],
      topBrands: [
        { brand: 'Nokia HMD', sales: 677436, marketShare: 29.5 },
        { brand: 'TCL', sales: 585670, marketShare: 25.5 },
        { brand: 'Alcatel', sales: 204203, marketShare: 8.9 },
        { brand: 'Schok', sales: 118218, marketShare: 5.2 },
        { brand: 'Lively', sales: 106546, marketShare: 4.6 }
      ]
    },
    2024: {
      totalMarket: 1457445,
      topModels: [
        { model: 'Nokia HMD 2780 Flip', brand: 'Nokia HMD', sales: 372382, marketShare: 25.6 },
        { model: 'TCL Flip 2', brand: 'TCL', sales: 191024, marketShare: 13.1 },
        { model: 'TCL Flip Go', brand: 'TCL', sales: 154663, marketShare: 10.6 },
        { model: 'TCL Flip 3', brand: 'TCL', sales: 107247, marketShare: 7.4 },
        { model: 'Alcatel SMARTFLIP', brand: 'Alcatel', sales: 83910, marketShare: 5.8 },
        { model: 'Hot Pepper Tabasco', brand: 'Hot Pepper', sales: 74241, marketShare: 5.1 },
        { model: 'Alcatel Go Flip V', brand: 'Alcatel', sales: 69796, marketShare: 4.8 },
        { model: 'Cricket Debut Flex', brand: 'Cricket', sales: 53066, marketShare: 3.6 }
      ],
      topChannels: [
        { channel: 'Walmart', sales: 486850, marketShare: 33.4 },
        { channel: 'USA Other', sales: 326706, marketShare: 22.4 },
        { channel: 'T-Mobile', sales: 119509, marketShare: 8.2 },
        { channel: 'Target', sales: 110510, marketShare: 7.6 },
        { channel: 'Best Buy', sales: 100033, marketShare: 6.9 },
        { channel: 'Verizon', sales: 86657, marketShare: 5.9 },
        { channel: 'Metro by T-Mobile', sales: 55323, marketShare: 3.8 },
        { channel: 'Boost', sales: 42838, marketShare: 2.9 }
      ],
      topBrands: [
        { brand: 'TCL', sales: 481136, marketShare: 33.0 },
        { brand: 'Nokia HMD', sales: 465771, marketShare: 32.0 },
        { brand: 'Alcatel', sales: 204549, marketShare: 14.0 },
        { brand: 'Hot Pepper', sales: 80654, marketShare: 5.5 },
        { brand: 'Cricket', sales: 53066, marketShare: 3.6 }
      ]
    },
    2025: {
      totalMarket: 391986,
      topModels: [
        { model: 'TCL Flip 3', brand: 'TCL', sales: 97334, marketShare: 24.8 },
        { model: 'Nokia HMD 2780 Flip', brand: 'Nokia HMD', sales: 61292, marketShare: 15.6 },
        { model: 'TCL Flip Go', brand: 'TCL', sales: 45262, marketShare: 11.5 },
        { model: 'TCL Flip 2', brand: 'TCL', sales: 40294, marketShare: 10.3 },
        { model: 'Lively Jitterbug Flip 2', brand: 'Lively', sales: 29022, marketShare: 7.4 },
        { model: 'HMD Barbie Phone', brand: 'Nokia HMD', sales: 28627, marketShare: 7.3 },
        { model: 'Hot Pepper Tabasco', brand: 'Hot Pepper', sales: 19228, marketShare: 4.9 },
        { model: 'Consumer Cellular Iris Easy Flip', brand: 'Consumer Cellular', sales: 12653, marketShare: 3.2 }
      ],
      topChannels: [
        { channel: 'USA Other', sales: 146715, marketShare: 37.4 },
        { channel: 'Walmart', sales: 119561, marketShare: 30.5 },
        { channel: 'T-Mobile', sales: 30332, marketShare: 7.7 },
        { channel: 'Spectrum', sales: 16703, marketShare: 4.3 },
        { channel: 'Best Buy', sales: 15697, marketShare: 4.0 },
        { channel: 'Target', sales: 14931, marketShare: 3.8 },
        { channel: 'Metro by T-Mobile', sales: 12345, marketShare: 3.1 },
        { channel: 'Amazon', sales: 10054, marketShare: 2.6 }
      ],
      topBrands: [
        { brand: 'TCL', sales: 195814, marketShare: 50.0 },
        { brand: 'Nokia HMD', sales: 90833, marketShare: 23.2 },
        { brand: 'Lively', sales: 29022, marketShare: 7.4 },
        { brand: 'Hot Pepper', sales: 19228, marketShare: 4.9 },
        { brand: 'Consumer Cellular', sales: 12653, marketShare: 3.2 }
      ]
    }
  };

  const channelColors = ['#3b82f6', '#ef4444', '#10b981', '#f59e0b', '#8b5cf6', '#06b6d4', '#84cc16', '#f97316'];

  const currentData = data[selectedYear];

  return (
    <div className="w-full max-w-7xl mx-auto p-6 bg-white space-y-8">
      {/* Header */}
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-2">
          US Feature Phone Market Analysis
        </h1>
        <p className="text-lg text-gray-600">
          Comprehensive Market Trends and Share Analysis 2022-2025
        </p>
      </div>

      {/* Sales Trend Section */}
      <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl border border-blue-200">
        <h2 className="text-2xl font-bold text-blue-800 mb-4 text-center">
          US Feature Phone Sales Trend
        </h2>
        
        <ResponsiveContainer width="100%" height={350}>
          <BarChart
            data={trendData}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
            <XAxis 
              dataKey="year" 
              tick={{ fontSize: 14, fontWeight: 'bold' }}
              axisLine={{ stroke: '#666' }}
            />
            <YAxis 
              tick={{ fontSize: 12 }}
              axisLine={{ stroke: '#666' }}
              tickFormatter={(value) => `${(value / 1000000).toFixed(1)}M`}
            />
            <Tooltip 
              formatter={(value) => [`${value.toLocaleString()} units`, 'Sales']}
              labelFormatter={(label) => label}
            />
            <Bar 
              dataKey="sales" 
              fill="#3b82f6"
              radius={[4, 4, 0, 0]}
              stroke="#2563eb"
              strokeWidth={1}
            />
          </BarChart>
        </ResponsiveContainer>

        {/* Trend Statistics */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
          {trendData.map((item, index) => (
            <div key={item.year} className="bg-white p-4 rounded-lg border border-blue-200 text-center">
              <h3 className="text-lg font-bold text-blue-800 mb-1">{item.year}</h3>
              <p className="text-2xl font-bold text-blue-600 mb-1">
                {item.salesMillions.toFixed(2)}M
              </p>
              <p className="text-xs text-gray-600">
                {item.sales.toLocaleString()} units
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Year Selector */}
      <div className="flex justify-center space-x-4">
        {['2022', '2023', '2024', '2025'].map(year => (
          <button
            key={year}
            onClick={() => setSelectedYear(year)}
            className={`px-6 py-3 rounded-lg font-semibold transition-all ${
              selectedYear === year 
                ? 'bg-blue-600 text-white shadow-lg' 
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            {year} {year === '2025' && '(Jan-May)'}
          </button>
        ))}
      </div>

      {/* Market Overview */}
      <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
        <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
          {selectedYear} Market Overview
        </h2>
        <div className="text-center">
          <p className="text-3xl font-bold text-blue-600 mb-2">
            {currentData.totalMarket.toLocaleString()} units
          </p>
          <p className="text-gray-600">
            Total Feature Phone Sales in {selectedYear} {selectedYear === '2025' && '(January - May 2025)'}
          </p>
        </div>
      </div>

      {/* Top Models Section */}
      <div>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          Top Models in {selectedYear} (with Market Share)
        </h2>
        <div className="bg-gray-50 p-4 rounded-lg">
          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              data={currentData.topModels.slice(0, 8)}
              margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis 
                dataKey="model" 
                angle={-45}
                textAnchor="end"
                height={100}
                interval={0}
                tick={{ fontSize: 10 }}
              />
              <YAxis 
                tickFormatter={(value) => `${(value / 1000).toFixed(0)}K`}
                tick={{ fontSize: 12 }}
              />
              <Tooltip 
                formatter={(value) => [`${value.toLocaleString()} units`, 'Sales']}
                labelFormatter={(label, payload) => {
                  if (payload && payload[0]) {
                    return `${label} (${payload[0].payload.marketShare}%)`;
                  }
                  return label;
                }}
              />
              <Bar 
                dataKey="sales" 
                fill="#3b82f6"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Channels and Brands Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Top Sales Channels */}
        <div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Sales Channels in {selectedYear}
          </h2>
          <div className="bg-gray-50 p-4 rounded-lg">
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={currentData.topChannels.slice(0, 8)}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={({ channel, marketShare }) => `${channel}: ${marketShare.toFixed(1)}%`}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="sales"
                  nameKey="channel"
                >
                  {currentData.topChannels.slice(0, 8).map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={channelColors[index % channelColors.length]} />
                  ))}
                </Pie>
                <Tooltip 
                  formatter={(value, name, props) => [
                    `${value.toLocaleString()} units (${props.payload.marketShare.toFixed(1)}%)`, 
                    'Sales'
                  ]}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Top Brands */}
        <div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Brand Market Share in {selectedYear}
          </h2>
          <div className="bg-gray-50 p-4 rounded-lg">
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                data={currentData.topBrands}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis 
                  dataKey="brand" 
                  tick={{ fontSize: 12 }}
                />
                <YAxis 
                  tickFormatter={(value) => `${(value / 1000).toFixed(0)}K`}
                  tick={{ fontSize: 12 }}
                />
                <Tooltip 
                  formatter={(value, name, props) => [
                    `${value.toLocaleString()} units (${props.payload.marketShare.toFixed(1)}%)`, 
                    'Sales'
                  ]}
                />
                <Bar 
                  dataKey="sales" 
                  fill="#10b981"
                  radius={[4, 4, 0, 0]}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Detailed Rankings Table */}
      <div>
        <h3 className="text-xl font-bold text-gray-800 mb-4">
          Detailed Market Share Rankings - {selectedYear}
        </h3>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <h4 className="font-semibold text-gray-700 mb-3">Top Models</h4>
            <div className="space-y-2">
              {currentData.topModels.slice(0, 5).map((model, index) => (
                <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100">
                  <div>
                    <span className="font-medium text-sm">{index + 1}. {model.brand}</span>
                    <p className="text-xs text-gray-600">{model.model}</p>
                  </div>
                  <div className="text-right">
                    <span className="font-semibold text-blue-600 text-sm">
                      {model.marketShare.toFixed(1)}%
                    </span>
                    <p className="text-xs text-gray-500">
                      {model.sales.toLocaleString()}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <h4 className="font-semibold text-gray-700 mb-3">Top Channels</h4>
            <div className="space-y-2">
              {currentData.topChannels.slice(0, 5).map((channel, index) => (
                <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100">
                  <span className="font-medium text-sm">{index + 1}. {channel.channel}</span>
                  <div className="text-right">
                    <span className="font-semibold text-green-600 text-sm">
                      {channel.marketShare.toFixed(1)}%
                    </span>
                    <p className="text-xs text-gray-500">
                      {channel.sales.toLocaleString()}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <h4 className="font-semibold text-gray-700 mb-3">Top Brands</h4>
            <div className="space-y-2">
              {currentData.topBrands.map((brand, index) => (
                <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100">
                  <span className="font-medium text-sm">{index + 1}. {brand.brand}</span>
                  <div className="text-right">
                    <span className="font-semibold text-purple-600 text-sm">
                      {brand.marketShare.toFixed(1)}%
                    </span>
                    <p className="text-xs text-gray-500">
                      {brand.sales.toLocaleString()}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Key Market Insights */}
      <div className="bg-blue-50 p-6 rounded-xl border border-blue-200">
        <h3 className="text-xl font-bold text-blue-800 mb-4">Key Market Insights</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h4 className="font-semibold text-blue-700 mb-2">Market Evolution</h4>
            <ul className="space-y-1 text-sm text-blue-600">
              <li>• Market declined 58% from 2022 to 2024</li>
              <li>• Walmart strengthened dominance (24.4% to 33.4%)</li>
              <li>• TCL overtook Nokia HMD as market leader in 2024</li>
              <li>• Flip phones dominate the feature phone segment</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-blue-700 mb-2">2025 Trends (Jan-May)</h4>
            <ul className="space-y-1 text-sm text-blue-600">
              <li>• TCL commands 50% market share</li>
              <li>• HMD Barbie Phone: Notable novelty product (7.3%)</li>
              <li>• USA Other channel gaining share (37.4%)</li>
              <li>• Spectrum emerging as distribution channel</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Data Source */}
      <div className="text-center text-xs text-gray-500">
        Source: USA Monthly Smartphone SellThrough Tracker by Channel (May 2025)
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <FeaturePhoneMarketDashboard />
    </div>
  );
}

export default App;
